import React, { FC, useState } from 'react';
import { IconButton } from '@mui/material';
import CachedIcon from '@mui/icons-material/Cached';

interface RefreshButtonProps {
    onClick?: () => void;
    fontSize?: number;
    color?: 'inherit' | 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
    animationEnabled?: boolean;
}

const RefreshButton: FC<RefreshButtonProps> = ({
                                                   onClick,
                                                   fontSize = 24,
                                                   color = 'inherit',
                                                   animationEnabled = true,
                                               }) => {
    const [rotating, setRotating] = useState(false);

    const handleClick = () => {
        if (onClick) onClick();

        if (animationEnabled) {
            setRotating(true);

            setTimeout(() => {
                setRotating(false);
            }, 600);
        }
    };

    return (

            <IconButton color={color} onClick={handleClick}>
                <CachedIcon
                    sx={{
                        fontSize,
                        transform: rotating ? 'rotate(-360deg)' : 'rotate(0deg)',
                        transition: animationEnabled && rotating
                            ? 'transform 0.6s ease-in-out'
                            : 'none',
                    }}
                />
            </IconButton>

    );
};

export default RefreshButton;
